import { TicketStatusBadge } from './TicketStatusBadge';

export type TicketStatus = 'open' | 'pending' | 'closed';

export type TicketPriority = 'low' | 'medium' | 'high';

export interface Ticket {
  id: string;
  title: string;

  status: TicketStatus;

  createdAt: string;

  category?: string;

  priority?: TicketPriority;

  customer?: {
    id: string;
    name: string;
  };

  service?: {
    id: string;
    name: string;
  };

  order?: {
    id: string;
    name?: string;
    status?: string;
  };

  wallet?: {
    balance?: string;
  };

  relations?: {
    customer?: boolean;
    service?: boolean;
    order?: boolean;
  };

  metadata?: Record<string, unknown>;
}

interface TicketRowProps {
  ticket: Ticket;
}

export function TicketRow({ ticket }: TicketRowProps) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-[var(--vania-colors-border-subtle,#222)] p-3">
      <div className="flex flex-col gap-1">
        <span className="text-sm text-[var(--vania-colors-text-primary,#fff)]">
          {ticket.title}
        </span>

        <span className="text-xs text-[var(--vania-colors-text-secondary,#999)]">
          #{ticket.id}
        </span>
      </div>

      <TicketStatusBadge status={ticket.status} />
    </div>
  );
}
